module.exports = __webpack_public_path__ + "static/media/bellabyte-redes-sociais-facebook-768x591.4b35ad9a.jpg";